var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('DynamicForm',{ref:"dynamicForm",attrs:{"getRoot":"/event","saveRoot":"/event","formStructure":_vm.dataFormStructures.event},on:{"onInitSuccess":_vm.onInitSuccess,"onSave":_vm.onSave,"onTrashClick":_vm.onTrashClick},model:{value:(_vm.dataId),callback:function ($$v) {_vm.dataId=$$v},expression:"dataId"}},[_vm._t("default",[_c('b-button',{staticClass:"ml-2",attrs:{"type":"button","variant":"success"},on:{"click":_vm.onReplaceEventDatesClick}},[_vm._v("\n                "+_vm._s(_vm.Core.Definition.getDefinition('Enr. et remplacer'))+"\n            ")])],{"slot":"afterFormButtons"}),_vm._t("default",[_c('Reminder',{model:{value:(_vm.dataReminder),callback:function ($$v) {_vm.dataReminder=$$v},expression:"dataReminder"}})],{"slot":"reminder"})],2),_c('ModalTrash',{ref:"trash",attrs:{"root":"/event","caption":_vm.Core.Definition.getDefinition('Suppression de l\'événement'),"message":_vm.Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer cet événement?')},on:{"onTrashSuccess":_vm.onTrashSuccess}}),_c('Modal',{ref:"modalReplaceEventDates",attrs:{"caption":_vm.Core.Definition.getDefinition('Enregistrer et remplacer le calendrier'),"hideFooter":true}},[_vm._t("default",[_c('DynamicForm',{ref:"dynamicFormReplaceEventDates",attrs:{"getRoot":"/event/replace","saveRoot":"/event","options":{
                        submit: {
                            text: 'Enregistrer et remplacer',
                            variant: 'primary'
                        }
                    },"formStructure":_vm.dataFormStructures.replace},on:{"onSave":_vm.onSaveReplaceEventDates},model:{value:(_vm.dataId),callback:function ($$v) {_vm.dataId=$$v},expression:"dataId"}},[_vm._t("default",[_c('b-alert',{attrs:{"show":"","variant":"info"}},[_vm._v("\n                        "+_vm._s(_vm.Core.Definition.getDefinition('Les événements futurs dans le calendrier seront mis à jour avec les nouvelles informations. Sélectionnez ci-dessous les informations que vous désirez remplacer.'))+"\n                    ")])],{"slot":"beforeForm"})],2)],{"slot":"body"})],2),_c('ModalInstanceSelector',{ref:"modalInstanceSelectorAddress",attrs:{"caption":_vm.Core.Definition.getDefinition('Liste des adresses'),"root":"/address/list","multiple":false,"distinct":true,"searchFormStructure":{
                        rows: [
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'id'
                                            }
                                        ]
                                    },
                                    {
                                        fields: [
                                            {
                                                id: 'title'
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'id',
                                type: 'number',
                                label: _vm.Core.Definition.getDefinition('ID'),
                                value: ''
                            },
                            {
                                id: 'title',
                                type: 'text',
                                label: _vm.Core.Definition.getDefinition('Titre'),
                                value: ''
                            }
                        ]
                    },"options":{
                            pagination: true,
                            header: true,
                            responsive: false,
                            striped: true,
                            headerStyle: '1',
                            emptyText: _vm.Core.Definition.getDefinition('Aucune adresse à afficher'),
                            borderVariant: 'white',
                            noBody: true
                     },"columns":[
                            {
                                label: _vm.Core.Definition.getDefinition('ID'),
                                key: 'id',
                                sortable: true
                            },
                            {
                                label: _vm.Core.Definition.getDefinition('Titre'),
                                key: 'title',
                                sortable: true
                            }
                     ]},model:{value:(_vm.dataAddress),callback:function ($$v) {_vm.dataAddress=$$v},expression:"dataAddress"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }